import React from "react";
import Dropdown from "../common/dropdown/Dropdown";

const ActionDropdown = ({
                            row,
                            view = true,
                            edit = true,
                            onDelete,
                            onUpdate,
                            formData = {},
                        }) => {
    const {id} = row;


    const actions = [];

    if (view) {
        actions.push({
            key: 'a',
            label: 'View',
            icon: 'eye',
            link: id,
        });
    }

    if (edit) {
        actions.push({
            key: 'b',
            label: 'Edit',
            icon: 'edit',
            link: `${id}/edit`,
        });
    }

    if (onDelete) {
        actions.push({
            id,
            key: 'c',
            label: "Delete",
            icon: "delete",
            confirm: true,
            confirmMessage: "Are you sure you want to delete?",
            clickHandler: (item) => onDelete(item.id),
        });
    }

    if (onUpdate) {
        actions.push({
            row,
            key: 'd',
            label: "Assign",
            icon: "update",
            form: true,
            formTitle: "Assign",
            formData,
            clickHandler: (data) => onUpdate(data),
        });
    }

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Dropdown
                className="btn-sm bg-transparent ms-auto"
                buttonIconSize="sm"
                buttonIcon="dots"
                list={actions}
                align="end"
            />
        </div>
    );
}
export default ActionDropdown;